import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useTipoComunicacao = () => {
  const [tipoComunicacao, setTipoComunicacao] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchTipoComunicacao = async () => {
      try {
        const response = await httpClient.get(
          `/api/fornecedorcomunicacao/tipocomunicacao`,
        );

        const options = response.data.map(
          (tipoComunicacao: { value: number; label: string }) => ({
            value: tipoComunicacao.value.toString(),
            label: tipoComunicacao.label,
          }),
        );
        setTipoComunicacao(options);
      } catch (error) {
        console.error('Erro ao buscar Tipo Comunicacao', error);
      }
    };

    fetchTipoComunicacao();
  }, []);

  return tipoComunicacao;
};
